export interface ArticleItem {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string[];
  category: string;
  categorySlug: string;
  date: string;
  readTime: string;
  imageSeq: string;
  tags: string[];
}

export const categoriesData = [
  {
    id: "anquan",
    name: "安全指南",
    slug: "anquan",
    description: "提供全面的网络安全知识，帮助用户识别钓鱼网站，保护个人信息与账户安全。",
    icon: "ri-shield-check-line",
  },
  {
    id: "rumen",
    name: "新手入门",
    slug: "rumen",
    description: "为新用户提供详细的注册、登录和基础功能使用教程，帮助快速上手平台。",
    icon: "ri-user-smile-line",
  },
  {
    id: "gonggao",
    name: "官方公告",
    slug: "gonggao",
    description: "发布91平台最新动态、系统升级通知、服务调整公告等权威官方信息。",
    icon: "ri-megaphone-line",
  },
  {
    id: "wenti",
    name: "常见问题",
    slug: "wenti",
    description: "汇总用户高频咨询问题，提供详细的解决方案和操作指引。",
    icon: "ri-question-answer-line",
  },
  {
    id: "dongtai",
    name: "平台动态",
    slug: "dongtai",
    description: "分享91平台的功能更新、活动资讯及行业相关动态内容。",
    icon: "ri-flashlight-line",
  },
];

export const articlesData: ArticleItem[] = [
  {
    id: "1",
    slug: "91guanwang-zhengban-rukou-bianbie",
    title: "91官网正版入口辨别指南：三步识别官方认证平台",
    excerpt: "随着网络钓鱼手段日益猖獗，学会辨别91官网正版入口至关重要。本文将从网址验证、安全证书、页面特征三个维度，教您快速识别官方认证平台。",
    content: [
      "在当今复杂的网络环境中，仿冒钓鱼网站层出不穷，给用户的账户安全和隐私信息带来了严重威胁。作为91平台的用户，掌握辨别正版官网入口的方法，是保护自身权益的第一道防线。",
      `第一步：验证网址准确性。正版91官网的网址具有唯一性，请仔细核对浏览器地址栏中的每一个字符。仿冒网站往往在拼写上做手脚，例如使用形近字符替换、增减字母等手段。建议您将官方网址添加到浏览器收藏夹，每次通过收藏夹访问，从源头杜绝误入仿冒网站的可能。`,
      `第二步：检查安全证书。正版91官网采用HTTPS加密协议，浏览器地址栏左侧会显示安全锁图标。点击该图标可以查看网站的SSL/TLS证书信息，确认证书颁发给正确的域名。如果地址栏显示"不安全"或证书信息异常，请立即停止操作并退出该页面。`,
      "第三步：观察页面特征。官方认证平台通常具有专业统一的视觉设计、规范的页面布局和完善的功能模块。而仿冒网站往往设计粗糙、排版混乱、存在大量弹窗广告，甚至要求用户提供超出正常范围的个人信息。",
      "此外，91官网还提供了官方验证渠道，用户可以通过客服咨询确认当前访问的页面是否为官方正版。我们建议所有用户养成定期检查的好习惯，确保每次访问的都是安全可靠的官方平台。",
    ],
    category: "安全指南",
    categorySlug: "anquan",
    date: "2026-08-01",
    readTime: "5分钟",
    imageSeq: "article-security-01",
    tags: ["官网辨别", "安全验证", "正版入口", "钓鱼防范"],
  },
  {
    id: "2",
    slug: "91guanwang-denglu-zhinan",
    title: "91官网登录完整指南：从注册到安全设置全流程",
    excerpt: "详细解说91官网的注册、登录及安全设置全流程，包含常见登录问题排查方法，帮助您顺畅使用平台各项功能。",
    content: [
      "对于初次使用91平台的用户来说，了解完整的注册和登录流程至关重要。本指南将从账号注册开始，逐步引导您完成所有设置，确保您能够安全顺畅地使用平台。",
      `账号注册流程：进入91官网首页，点击"注册"按钮进入注册页面。按照提示填写必要的个人信息，包括手机号码、设置密码等。系统会向您的手机发送验证码，输入正确的验证码后即可完成注册。请务必使用本人真实信息，以便后续进行实名认证。`,
      `登录操作步骤：注册成功后，在官网首页点击"登录"按钮，输入您的账号（手机号）和密码，点击确认即可登录。如果您在常用设备上登录，可以勾选"记住我"选项，方便下次快速访问。但请注意，在公共设备上不建议使用此功能。`,
      "安全设置建议：登录后，建议立即完成以下安全设置：开启双重验证功能，绑定备用手机号或邮箱作为账户恢复方式，设置支付密码以保护资金安全，定期修改登录密码并使用强密码组合。",
      `常见登录问题：如忘记密码，可点击登录页面的"忘记密码"链接，通过绑定的手机号或邮箱重置密码。如账号被锁定，请等待15分钟后重试或联系客服解锁。如遇到验证码收不到的情况，请检查手机信号和短信拦截设置。`,
      "通过以上步骤和注意事项，您可以在保障账户安全的前提下，充分享受91平台提供的各项优质服务。",
    ],
    category: "新手入门",
    categorySlug: "rumen",
    date: "2026-07-28",
    readTime: "8分钟",
    imageSeq: "article-login-02",
    tags: ["登录指引", "账号注册", "安全设置", "常见问题"],
  },
  {
    id: "3",
    slug: "91guanwang-zuixin-dizhi-gonggao",
    title: "关于91官网最新地址的官方声明与公告",
    excerpt: "针对近期网络上流传的各类91官网地址信息，现发布官方声明，明确唯一正版入口地址，提醒用户警惕虚假信息。",
    content: [
      "近期，我们注意到网络上出现了大量关于91官网地址的不实信息，部分不法分子通过发布虚假地址链接，诱导用户访问仿冒网站，严重威胁用户的信息安全和合法权益。",
      `官方郑重声明：91官网的唯一正版入口为本网站所公布的地址。我们从未授权任何第三方平台或个人发布所谓的"最新地址"或"备用入口"。请广大用户以本官方页面公布的信息为准，切勿轻信其他渠道传播的地址信息。`,
      `如果您收到来自不明来源的短信、邮件或社交媒体私信，其中包含指向所谓"91官网"的链接，请立即删除，不要点击。这些链接极有可能导向钓鱼网站，一旦输入账号密码等敏感信息，将导致账户被盗用。`,
      "我们建议用户采取以下措施保障安全：将本官方页面添加到浏览器收藏夹；关注平台官方公告渠道；定期访问本页面获取最新信息；发现可疑链接时及时向官方客服举报。",
      "91平台始终将用户安全放在首位，我们将持续加强网络安全防护，严厉打击仿冒钓鱼行为，为用户营造安全可靠的网络环境。感谢每一位用户的理解与支持。",
    ],
    category: "官方公告",
    categorySlug: "gonggao",
    date: "2026-08-03",
    readTime: "4分钟",
    imageSeq: "article-announce-03",
    tags: ["官方公告", "最新地址", "安全声明", "防骗提醒"],
  },
  {
    id: "4",
    slug: "91guanwang-mima-zhaohui-jiaocheng",
    title: "忘记密码怎么办？91官网密码找回详细教程",
    excerpt: "忘记登录密码是常见问题，本文档提供完整的密码找回流程，包含多种找回方式的操作步骤和注意事项。",
    content: [
      "忘记密码是很多用户都会遇到的情况，不必担心，91平台提供了便捷安全的密码找回机制。本文将详细介绍所有可用的密码找回方式。",
      `方式一：手机验证码找回。在登录页面点击"忘记密码"，选择"通过手机号找回"。输入您注册时使用的手机号码，点击"获取验证码"，将收到的短信验证码填入后，即可设置新密码。新密码建议包含大小写字母、数字和特殊字符的组合，长度不少于8位。`,
      `方式二：绑定邮箱找回。如果您在账号设置中绑定了邮箱，可以选择"通过邮箱找回"。系统会向您的绑定邮箱发送一封包含重置链接的邮件，点击链接后按照页面提示设置新密码即可。请注意查收邮件时也要检查垃圾邮件箱。`,
      "方式三：客服协助找回。如果以上方式均无法使用（如手机号已更换、邮箱无法访问），您可以联系官方客服，提供身份验证信息后，由客服协助完成密码重置。此方式可能需要更长的处理时间。",
      "重置密码后，建议您立即登录账号，检查账户安全设置，确认绑定信息是否正确。同时，为了账户安全，建议不要在多个平台使用相同的密码。",
    ],
    category: "常见问题",
    categorySlug: "wenti",
    date: "2026-07-25",
    readTime: "6分钟",
    imageSeq: "article-password-04",
    tags: ["密码找回", "账号安全", "操作教程", "常见问题"],
  },
  {
    id: "5",
    slug: "91guanwang-shiming-renzheng-zhongyao",
    title: "实名认证为什么重要？91官网安全机制深度解析",
    excerpt: "深入解析91平台实名认证机制的重要性和运作原理，了解实名制如何为您的账户安全保驾护航。",
    content: [
      "实名认证是91平台安全体系的核心基石。通过实名认证，平台能够有效确认用户身份的真实性，从而构建一个安全可靠的网络环境。本文将深入为您解析实名认证的重要性和运作机制。",
      "实名认证的重要性：第一，有效防范虚假注册和恶意操作。实名制使得每个账号都对应真实身份，大幅增加了不法分子批量注册虚假账号的难度。第二，为账户安全提供保障。当您的账号出现异常操作时，实名信息是您找回账号的重要凭证。第三，营造诚信社区环境。实名制能够有效减少网络欺诈、恶意评论等不良行为。",
      "实名认证流程：用户需提供真实姓名和有效身份证件号码。平台通过权威数据源进行信息比对核验，整个过程通常在几分钟内完成。认证信息采用加密存储，严格保护用户隐私。",
      "隐私保护措施：平台严格遵守相关法律法规，对用户的实名信息进行加密处理和分级管理。只有经过严格授权的安全系统才能访问相关数据，且所有访问操作均有日志记录，可追溯、可审计。",
      "我们理解部分用户对隐私保护的担忧。请放心，91平台在信息安全方面投入了大量资源，采用了业界领先的技术手段和管理措施，确保您的个人信息安全无虞。",
    ],
    category: "安全指南",
    categorySlug: "anquan",
    date: "2026-07-20",
    readTime: "7分钟",
    imageSeq: "article-verify-05",
    tags: ["实名认证", "安全机制", "隐私保护", "账户安全"],
  },
  {
    id: "6",
    slug: "91guanwang-xinshou-shangshou-zhinan",
    title: "91平台新手上手指南：从零开始玩转所有功能",
    excerpt: "专为新用户准备的全面上手指南，涵盖平台核心功能模块的详细使用说明，助您快速成为熟练用户。",
    content: [
      "欢迎加入91平台！作为新用户，您可能对平台的各种功能还不太熟悉。别担心，这篇指南将带您从零开始，逐步了解和掌握平台的核心功能和操作技巧。",
      "第一步：完善个人资料。登录后，首先进入个人中心页面，上传头像、设置昵称、完善个人简介。一个完整的个人资料不仅能提升您的可信度，也有助于获得更好的平台体验。",
      "第二步：了解核心功能模块。平台主界面分为多个功能区，包括内容浏览区、互动交流区、个人管理中心等。建议您花一些时间逐一浏览各个模块，了解它们的基本功能和使用方式。",
      "第三步：学习常用操作。掌握搜索功能可以快速找到您感兴趣的内容；学会使用收藏功能可以保存重要信息；了解消息通知系统不会错过任何重要动态。",
      "第四步：探索进阶功能。当您熟悉基本操作后，可以尝试使用更多高级功能，如自定义设置、数据统计查看、个性化推荐等，进一步提升使用体验。",
      "如果在使用过程中遇到任何问题，随时可以查阅帮助中心的相关文档，或者联系在线客服获取协助。祝您使用愉快！",
    ],
    category: "新手入门",
    categorySlug: "rumen",
    date: "2026-07-15",
    readTime: "10分钟",
    imageSeq: "article-guide-06",
    tags: ["新手指南", "功能教程", "平台介绍", "上手教程"],
  },
  {
    id: "7",
    slug: "91guanwang-yidongduan-fangwen",
    title: "移动端访问91官网的正确方式与注意事项",
    excerpt: "随着移动互联网的普及，越来越多的用户选择通过手机访问91官网。本文介绍移动端访问的正确方式。",
    content: [
      "移动互联网时代，手机已经成为用户访问网站的主要设备。91官网针对移动端进行了全面的适配优化，确保用户在任何设备上都能获得流畅的使用体验。",
      "浏览器访问：使用手机自带的浏览器或主流第三方浏览器，直接输入官方网址即可访问91官网。网站采用响应式设计技术，会自动适配不同尺寸的屏幕，确保页面显示效果最佳。建议将官网添加到手机主屏幕，方便快速访问。",
      "移动端特色功能：移动版官网针对触屏操作进行了优化，包括更大的点击区域、流畅的滑动体验、便捷的手势操作等。同时，移动端也支持完整的账户管理功能，包括登录、注册、密码修改等操作。",
      "安全注意事项：在移动端访问时，同样需要注意网络安全。避免使用公共WiFi登录账号，不要将验证码告知他人，定期清理浏览器缓存，及时更新手机系统和浏览器版本。",
      "如果您在使用移动版官网过程中遇到显示异常或功能问题，建议尝试清除浏览器缓存或更换其他浏览器重试。持续性的问题可以反馈给客服团队。",
    ],
    category: "平台动态",
    categorySlug: "dongtai",
    date: "2026-07-10",
    readTime: "5分钟",
    imageSeq: "article-mobile-07",
    tags: ["移动端", "手机访问", "使用技巧", "安全注意"],
  },
  {
    id: "8",
    slug: "91guanwang-changjian-yuqing-wenti",
    title: "91官网常见舆情问题统一回复与辟谣",
    excerpt: "针对网络上关于91平台的热点舆情和常见疑问，本文进行统一回复和辟谣，以正视听。",
    content: [
      "网络信息纷繁复杂，关于91平台的各种说法和传言时有出现。作为官方渠道，我们有责任对常见舆情问题进行澄清，帮助用户获取准确信息。",
      `问题一："91平台是否即将停止运营？"——此为虚假消息。91平台运营一切正常，各项服务稳定运行。请用户以官方公告为准，不要轻信未经证实的传言。`,
      `问题二："是否需要下载特定软件才能使用？"——91平台为网页端服务，无需下载安装任何额外软件即可正常使用。任何以"客户端下载"为名要求您安装程序的行为都可能是诈骗。`,
      `问题三："收费政策是否即将调整？"——关于收费相关的政策调整，平台会通过官方公告提前通知用户。目前没有任何价格调整的计划。`,
      "我们建议用户养成从官方渠道获取信息的习惯。对于不确定的消息，可以通过客服渠道进行核实。同时，我们也呼吁大家不传谣、不信谣，共同维护良好的网络环境。",
    ],
    category: "官方公告",
    categorySlug: "gonggao",
    date: "2026-07-05",
    readTime: "6分钟",
    imageSeq: "article-rumor-08",
    tags: ["辟谣声明", "舆情回应", "官方信息", "用户须知"],
  },
  {
    id: "9",
    slug: "91guanwang-zhanghu-yichang-chuli",
    title: "账户异常情况处理指南：被盗、冻结、限制解决方案",
    excerpt: "遇到账户被盗、冻结或功能限制等异常情况时，应该如何处理？本文提供全面的解决方案和预防建议。",
    content: [
      "账户异常是每位用户都不愿遇到的情况，但提前了解处理方法可以在问题发生时从容应对。本文汇总了常见的账户异常情况及处理方案。",
      "账户被盗处理：如果发现账户出现非本人操作的登录记录、资料被修改或资金异常变动，请立即联系官方客服进行账户冻结。同时，尽快修改密码、检查并更新安全设置。客服团队会协助您进行账户恢复和损失评估。",
      "账户冻结解决：账户冻结通常是由于安全检测系统发现异常操作而触发的保护机制。如确认是本人操作，可按照系统提示进行身份验证解冻。如不确定原因，请联系客服查询冻结原因和处理方法。",
      "功能限制处理：某些功能可能因为账户安全等级不足或未完成相关认证而被限制。通常在完成相应的安全设置或认证后，功能限制会自动解除。具体可查看个人中心的安全等级提示。",
      "预防措施建议：开启所有可用的安全保护功能，定期检查账户活动记录，不与他人共享账号密码，使用强密码并定期更换，保持绑定手机号和邮箱的有效性。",
    ],
    category: "常见问题",
    categorySlug: "wenti",
    date: "2026-06-28",
    readTime: "8分钟",
    imageSeq: "article-account-09",
    tags: ["账户异常", "安全处理", "账户冻结", "解决方案"],
  },
];

export function getArticlesByCategory(slug: string): ArticleItem[] {
  return articlesData.filter((article) => article.categorySlug === slug);
}

export function getArticleBySlug(slug: string): ArticleItem | undefined {
  return articlesData.find((article) => article.slug === slug);
}

export function getLatestArticles(count: number = 6): ArticleItem[] {
  return articlesData.slice(0, count);
}

export function getCategoryBySlug(slug: string) {
  return categoriesData.find((cat) => cat.slug === slug);
}

export function getRelatedArticles(currentSlug: string, categorySlug: string, count: number = 4): ArticleItem[] {
  return articlesData
    .filter((article) => article.categorySlug === categorySlug && article.slug !== currentSlug)
    .slice(0, count);
}